import type {} from "@lit/react";
import { GridTreeColumn as GridTreeColumnElement, } from "@vaadin/grid/vaadin-grid-tree-column.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridTreeColumnElement, };
export type GridTreeColumnEventMap = Readonly<{}>;
const events = {} as GridTreeColumnEventMap;
export type GridTreeColumnProps<T1> = WebComponentProps<GridTreeColumnElement<T1>, GridTreeColumnEventMap>;
export const GridTreeColumn = createComponent({
    elementClass: GridTreeColumnElement, events, react: React, tagName: "vaadin-grid-tree-column"
}) as <T1>(props: GridTreeColumnProps<T1> & React.RefAttributes<GridTreeColumnElement<T1>>) => React.ReactElement | null;
